import { showToast } from "../components";
import { fetchAllImmigrations } from "../redux/slices/immigration/immigrationApi";
import CryptoJS from "crypto-js";
import { shortenCompanyName } from "./shortenCompanyName";
import { parsePhoneNumberFromString  } from 'libphonenumber-js';
import dayjs from "dayjs";
import { updateEmpDeductions } from "../redux/slices/payroll/payrollApi";
import { updateTimesheet } from "../redux/slices/timesheets/timesheetApi";
import { exactUTCDate } from "./dateFormator";
import { convertFromUTC, convertToUTC } from "./dateUtils";
import { localeTimeFormatOptions, localeTimeZoneOptions } from "../assets/data/enumData";

const ENCRYPTION_KEY = import.meta.env.VITE_AES_KEY;
function mergeEntries(data) {
  if (!Array.isArray(data) || data.length === 0) return [];

  let allEntries = [];
  let uiidCombine = [];
  let mongoId = [];
  let fromDates = [];
  let toDates = [];

  data.forEach((periodBlock) => {
    const { dailyEntries, uiid, _id, period } = periodBlock;

    // Append dailyEntries with added uiid
    dailyEntries.forEach((entry) => {
      allEntries.push({ ...entry, uiid });
    });

    // Collect combined metadata
    uiidCombine.push(uiid);
    mongoId.push(_id);
    fromDates.push(dayjs.utc(period.from).toDate());
    toDates.push(dayjs.utc(period.to).toDate());
  });

  // Sort entries by date
  allEntries.sort((a, b) => a.date - b.date);

  // Get min(fromDates) and max(toDates)
  const from = new Date(Math.min(...fromDates)).toISOString();
  const to = new Date(Math.max(...toDates)).toISOString();

  return [
    {
      period: { from, to },
      dailyEntries: allEntries,
      uiidCombine,
      uiid: uiidCombine[0],
      mongoId,
    },
  ];
}

const getCombinedDateRange = (data = []) => {
  return data.reduce(
    (range, item) => {
      const { from, to } = item.period;

      if (!range.from || from < range.from) {
        range.from = from;
      }

      if (!range.to || to > range.to) {
        range.to = to;
      }

      return range;
    },
    { from: null, to: null }
  );
};
async function splitByCase(
  data = [],
  type = 1,
  weekStartDay,
  val,
  apexDates = []
) {
  const { from : startDate, to : endDate } = await getCombinedDateRange(data);
  // console.log({startDate,endDate});
  // const startDate = new Date(from);
  // const endDate = new Date(to);
  const result = [];
  switch (type) {
    // case 1:
    // case 2: {
    //   if (weekStartDay === undefined)
    //     throw new Error("Missing or invalid weekStartDay");
    //   const interval = type === 2 ? 14 : 7;
    //   // Find first start date aligned with weekStartDay
    //   const firstStart = new Date(startDate);
    //   while (firstStart.getDay() !== weekStartDay) {
    //     firstStart.setDate(firstStart.getDate() - 1);
    //   }
    //   let currentStart = new Date(firstStart);
    //   while (currentStart <= endDate) {
    //     const currentEnd = new Date(currentStart);
    //     currentEnd.setDate(currentEnd.getDate() + interval - 1);
    //     result.push({
    //       from: new Date(currentStart).toISOString(),
    //       to: new Date(
    //         currentEnd < endDate ? currentEnd : endDate
    //       ).toISOString(),
    //       type: type,
    //     });
    //     currentStart.setDate(currentStart.getDate() + interval);
    //   }
    //   break;
    // }
    // case 3: {
    //   let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    //   console.log("current", current);
    //   while (current <= endDate) {
    //     const y = current.getFullYear();
    //     const m = current.getMonth();
    //     const fifteenth = new Date(y, m, 15);
    //     const last = new Date(y, m + 1, 0); // end of month
    //     const part1From = current;
    //     const part1To = fifteenth < endDate ? fifteenth : endDate;
    //     if (part1From <= part1To) {
    //       result.push({
    //         from: part1From.toISOString(),
    //         to: part1To.toISOString(),
    //         type: type,
    //       });
    //     }

    //     const part2From = new Date(y, m, 16);
    //     const part2To = last < endDate ? last : new Date(endDate);
    //     if (part2From <= part2To) {
    //       result.push({
    //         from: part2From.toISOString(),
    //         to: part2To.toISOString(),
    //         type: type,
    //       });
    //     }

    //     current.setMonth(current.getMonth() + 1);
    //   }
    //   break;
    // }
        case 1:
        case 2: {
        if (weekStartDay === undefined) throw new Error("Missing or invalid weekStartDay");
        const interval = type === 2 ? 14 : 7;

        let currentStart = dayjs(startDate).utc().startOf("day");
        // while (currentStart.day() !== weekStartDay) {
        //   console.log("1")
        //   currentStart = currentStart.subtract(1, "day");
        // }
      const normalizeWeekday = (w) => (w === 7 ? 0 : w);
        let attempts = 0;
        const targetWeekday = normalizeWeekday(weekStartDay);
        console.log({currentStart,currentStartDay:currentStart.day(),targetWeekday})
        while (currentStart.day() !== targetWeekday) {
          currentStart = currentStart.subtract(1, "day");
          attempts++;
          if (attempts > 7) {
            throw new Error("weekStartDay unreachable — invalid date or weekStartDay");
          }
        }

        while (currentStart <= dayjs(endDate).utc()) {
          console.log("2")
          const currentEnd = currentStart.add(interval - 1, "day");
          result.push({
            from: currentStart.toDate().toISOString(),
            to: (currentEnd <= dayjs(endDate).utc() ? currentEnd : dayjs(endDate).utc()).toDate().toISOString(),
            type: type,
          });
          currentStart = currentStart.add(interval, "day");
        }
        break;
      }

      case 3: {
        let current = dayjs(startDate).utc().startOf("month");
        const end = dayjs(endDate).utc();

        while (current <= end) {
          const fifteenth = current.date(15).endOf("day");
          const monthEnd = current.endOf("month");

          const part1From = current;
          const part1To = fifteenth <= end ? fifteenth : end;
          if (part1From <= part1To) {
            result.push({
              from: part1From.toDate().toISOString(),
              to: part1To.toDate().toISOString(),
              type: type,
            });
          }

          const part2From = current.date(16).startOf("day");
          const part2To = monthEnd <= end ? monthEnd : end;
          if (part2From <= part2To) {
            result.push({
              from: part2From.toDate().toISOString(),
              to: part2To.toDate().toISOString(),
              type: type,
            });
          }

          current = current.add(1, "month").startOf("month");
        }
        break;
      }

    // case 4: {
    //   // let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    //   let current = new Date(new Date(startDate).getFullYear(), new Date(startDate).getMonth(), 1);
    //   while (current <= new Date(endDate)) {
    //     const y = current.getFullYear();
    //     const m = current.getMonth();
    //     const monthStart = new Date(y, m, 1);
    //     const monthEnd = new Date(y, m + 1, 0);
    //     result.push({
    //       from: monthStart.toISOString(),
    //       to: (monthEnd >= new Date(endDate) ? new Date(endDate) : monthEnd).toISOString(),
    //       type: type,
    //     });
    //     current.setMonth(m + 1);
    //   }
    //   break;
    // }
    case 4: {
      const startDateDayjs = dayjs(startDate).utc();
      const endDateDayjs = dayjs(endDate).utc();
      let currentDayjs = startDateDayjs.startOf("month");

      while (currentDayjs <= endDateDayjs) {
        console.log(`Current date: ${currentDayjs.toDate().toISOString()}`);

        const monthStart = currentDayjs.toDate();
        const monthEnd = currentDayjs.endOf("month");

        result.push({
          from: monthStart.toISOString(),
          to: (monthEnd >= endDateDayjs ? endDateDayjs.toDate() : monthEnd).toISOString(),
          type: type,
        });

        currentDayjs = currentDayjs.add(1, "month");
      }
      break;
    }
    case 5: {
      if (val?.from && val?.to) {
        result.push({ ...val, type });
      }
      break;
    }
    // AppEx Calendar case
    case 6: {
      apexDates.forEach((entry) => {
        result.push({ ...entry, type });
      });
      break;
    }
    default:
      throw new Error(`Unsupported case type: ${type}`);
  }
  return result;
}
function mapDailyEntriesToRanges(
  data,
  exampleRanges,
  frequency,
  companyName,
  userFirstName,
  jobTitle,
  jobPlacement
) {
  const convertToDate = (yyyymmdd) => {
    const str = yyyymmdd.toString();
    return new Date(
      Number(str.slice(0, 4)),
      Number(str.slice(4, 6)) - 1,
      Number(str.slice(6, 8))
    );
  };
  return data.map((user) => ({
    uiid: user.uiid,
    type: frequency,
    companyName: companyName,
    empName: userFirstName,
    jobTitle:jobTitle,
    jobPlacement:jobPlacement,
    ranges: exampleRanges.map((range) => {
      // const from = new Date(range.from);
      // const to = Date.UTC(new Date(range.to).getFullYear(), new Date(range.to).getMonth(), new Date(range.to).getDate());
      // const dailyEntries = user.dailyEntries.filter((entry) => {
      //   const entryDate = convertToDate(entry.date);
      //   console.log({entry, entryDate});
      //   return entryDate >= from && entryDate <= to;
      // });
      const from = dayjs(exactUTCDate(range.from));
      const to = dayjs(exactUTCDate(range.to));
      // console.log({from, to});
      const dailyEntries = user.dailyEntries.filter((entry) => {
        // const entryDate = convertToDate(entry.date);
        const entryDate = dayjs(String(entry.date), 'YYYYMMDD');
        // return entryDate >= from && entryDate <= to;
        // console.log("entryDate",{from,to}, entryDate,entryDate >= from && entryDate <= to,exactUTCDate(entryDate.toDate()));
        // return entryDate.isBetween(from, to);
        return entryDate >= from && entryDate <= to;
      });

      return {
        ...range,
        dailyEntries,
      };
    }),
  }));
}
function calculateDiscountedTotal(baseAmount = 0, discounts = []) {
  baseAmount = parseFloat(baseAmount) || 0;
  discounts = Array.isArray(discounts) ? discounts : [];
  let totalPercentage = 0;
  let totalFixedValue = 0;

  discounts.forEach((discount) => {
    const val = parseFloat(discount.value);
    const type = parseInt(discount.type);
    if (!isNaN(val)) {
      if (type === 1) {
        totalPercentage += val;
      } else if (type === 2) {
        totalFixedValue += val;
      }
    }
  });

  // Optional cap: avoid 100% total discount
  if (totalPercentage >= 100) {
    console.warn("Total percentage discount exceeds 100%");
    totalPercentage = 99.99; // or return 0 or throw an error
  }

  const discountedAmount =
    baseAmount * (1 - totalPercentage / 100) - totalFixedValue;
  console.log("discountedAmount", discountedAmount);
  return Number(discountedAmount.toFixed(2));
}

const updateImmigrationData = async (
  collection,
  ref,
  fieldName,
  returnField,
  filter,
  allData
) => {
  console.log("fieldName", fieldName);
  const fieldData = allData?.immigrations?.[fieldName] || [];
  console.log("fieldData", fieldData);
  if (fieldData.length > 0) {
    try {
      // Fetch data from the API
      const response = await fetchAllImmigrations({
        coll: collection,
        ret: returnField, // `ret` is now `returnField`
        ref,
        filter,
      });

      // If the response is successful, update the data
      if (response.success) {
        console.log(`${fieldName} Response:`, response);
        return {
          ...allData,
          immigrations: {
            ...allData.immigrations,
            [fieldName]: response?.data?.data || [], // Fallback to empty array if no data
          },
        };
      } else {
        console.warn(`No data found for ${fieldName}`);
        return allData; // Return unchanged `allData` if no data found
      }
    } catch (error) {
      // Catch any errors but don't interrupt the flow
      console.error(`Error fetching data for ${fieldName}:`, error);
      return allData; // Return unchanged `allData` in case of an error
    }
  } else {
    // If fieldData is empty or not available, simply return allData without any changes
    return allData;
  }
};

function groupDatesByUiid(data) {
  const uiidDates = {};
  // Check if data is an array and not empty
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }
  // Iterate over the dailyEntries and group by uiid
  data.forEach((item) => {
    // Check if the item has a valid 'dailyEntries' array
    if (item && Array.isArray(item.dailyEntries)) {
      item.dailyEntries.forEach((entry) => {
        // Check if entry and uiid, date are valid
        const { uiid, date } = entry || {};
        if (uiid && date) {
          // Initialize the array if not already present for the uiid
          if (!uiidDates[uiid]) {
            uiidDates[uiid] = [];
          }
          // Avoid duplicate dates
          if (!uiidDates[uiid].includes(date)) {
            uiidDates[uiid].push(date);
          }
        }
      });
    }
  });
  // Convert the grouped data into the desired format
  return Object.keys(uiidDates).map((uiid) => ({
    id: parseInt(uiid, 10),
    dates: uiidDates[uiid],
  }));
}
const validateFormFields = (validateAllFields) => {
  const isValid = validateAllFields(); // Calls your existing validation logic
  if (!isValid) {
    showToast("Please fill all the required fields before proceeding", "error", 3000); // Show toast message if validation fails
  }
  return isValid; // Returns whether validation passed or failed
};

const formatDate = (date) => {
  // console.log("date",date);
  // const month = String(date.getMonth() + 1).padStart(2, "0");
  // const day = String(date.getDate()).padStart(2, "0");
  // const year = date.getFullYear();
  // return `${month}/${day}/${year}`;
  return dayjs(date).isValid() ? dayjs(date).format("MM/DD/YYYY") : "";
};
// const generateMonthStartToEnd = (
//   startMonth,
//   howMany = null,
//   endDate = null
// ) => {
//   // Helper function to get the start and end date of a specific month
//   const getMonthRange = (monthOffset, customEndDate) => {
//     const startOfMonth = new Date(startMonth); // Start from the provided starting month
//     startOfMonth.setMonth(startOfMonth.getMonth() + monthOffset);

//     let endOfMonth;
//     if (monthOffset === 0 && customEndDate) {
//       // If it's the first month, apply the custom end date
//       endOfMonth = new Date(customEndDate);
//     } else {
//       // Otherwise, calculate the last day of the month
//       endOfMonth = new Date(
//         startOfMonth.getFullYear(),
//         startOfMonth.getMonth() + 1,
//         0
//       );
//     }

//     return {
//       start: startOfMonth,
//       end: endOfMonth,
//     };
//   };

//   // Generate the labels
//   let labels = [];

//   if (endDate) {
//     let current = new Date(startMonth);
//     const finalDate = new Date(endDate);

//     while (current <= finalDate) {
//       const startOfMonth = new Date(
//         current.getFullYear(),
//         current.getMonth(),
//         1
//       );
//       // Set end of the current range
//       const isLastMonth =
//         current.getMonth() === finalDate.getMonth() &&
//         current.getFullYear() === finalDate.getFullYear();

//       const endOfMonth = isLastMonth
//         ? new Date(finalDate) // Use exact end date for last month
//         : new Date(current.getFullYear(), current.getMonth() + 1, 0); // Else, last day of month

//       labels.push({
//         label: `${formatDate(startOfMonth)}-${formatDate(endOfMonth)}`,
//         // value: `${formatDate(startOfMonth)}-${formatDate(endOfMonth)}`,
//         value: {
//              from:startOfMonth,
//              to:endOfMonth
//         },
//       });

//       current.setMonth(current.getMonth() + 1);
//     }
//   } else if (howMany) {
//     // Case 1: Start from startMonth and generate howMany months
//     for (let i = 0; i < howMany; i++) {
//       const { start, end } = getMonthRange(i, null);
//       labels.push({
//         label: `${formatDate(start)}-${formatDate(end)}`,
//         value: {
//              from:start,
//              to:end
//         },
//       });
//     }
//   }

//   return labels;
// };
// const generateMonthStartToEnd = (startMonth, howMany = null, endDate = null) => {
//   const labels = [];
//   if (endDate) {
//     let current = dayjs(startMonth).startOf('month');
//     const finalDate = dayjs(endDate);
//     while (current.isBefore(finalDate) || current.isSame(finalDate, 'month')) {
//       const isLastMonth = current.isSame(finalDate, 'month');
//       const startOfMonth = current.startOf('month');
//       const endOfMonth = isLastMonth ? finalDate : current.endOf('month');
//       labels.push({
//         label: `${startOfMonth.format('MM-DD-YYYY')}-${endOfMonth.format('MM-DD-YYYY')}`,
//         value:`${startOfMonth.format('MM-DD-YYYY')}-${endOfMonth.format('MM-DD-YYYY')}`,
//          dates:{from:startOfMonth.toDate(),to:endOfMonth.toDate()}
//       });
//       current = current.add(1, 'month');
//     }
//   } else if (howMany) {
//     let current = dayjs(startMonth).startOf('month');
//     for (let i = 0; i < howMany; i++) {
//       const startOfMonth = current.startOf('month');
//       const endOfMonth = current.endOf('month');
//       labels.push({
//         label: `${startOfMonth.format('MM-DD-YYYY')}-${endOfMonth.format('MM-DD-YYYY')}`,
//       value:`${startOfMonth.format('MM-DD-YYYY')}-${endOfMonth.format('MM-DD-YYYY')}`,
//         dates:{from:startOfMonth.toDate(),to:endOfMonth.toDate()}
//       });
//       current = current.add(1, 'month');
//     }
//   }
//   return labels;
// };
function generateMonthStartToEnd(startMonth, howMany = null, endDate = null) {
  const labels = [];
  if (!startMonth) return labels; // invalid input
  let current = dayjs(startMonth).startOf('month');
  if (endDate) {
    // Mode 1: Generate months until endDate (inclusive)
    const finalDate = dayjs(endDate).endOf('month');
    while (current.isBefore(finalDate) || current.isSame(finalDate, 'month')) {
      const startOfMonth = current.startOf('month');
      const endOfMonth = current.endOf('month');
      const label = `${startOfMonth.format('MM/DD/YYYY')} - ${endOfMonth.format('MM/DD/YYYY')}`;
      labels.push({
        label,
        value: label,
        // dates: { from: startOfMonth.toDate(), to: endOfMonth.toDate() },
        dates: { from: startOfMonth, to: endOfMonth },
      });
      current = current.add(1, 'month');
    }
  } else if (howMany) {
    // Mode 2: Fixed number of months
    for (let i = 0; i < howMany; i++) {
      const startOfMonth = current.startOf('month');
      const endOfMonth = current.endOf('month');
      const label = `${startOfMonth.format('MM/DD/YYYY')} - ${endOfMonth.format('MM/DD/YYYY')}`;
      labels.push({
        label,
        value: label,
        dates: { from: startOfMonth.toDate(), to: endOfMonth.toDate() },
      });

      current = current.add(1, 'month');
    }
  }

  return labels;
}

const convertEntryption = (text) => {
  const encryptedPassword = CryptoJS.AES.encrypt(
    text,
    ENCRYPTION_KEY
  ).toString();
  if (!ENCRYPTION_KEY) {
    console.error("Encryption key is missing");
    throw new Error("Configuration error");
  }
  return encryptedPassword;
};
const isValidDiscount = (discount, index) => {
  const errors = [];

  const hasAnyField =
    discount &&
    ((typeof discount.name === "string" && discount.name.trim() !== "") ||
      discount.value !== undefined ||
      (typeof discount.comment === "string" && discount.comment.trim() !== ""));

  if (!hasAnyField) {
    // Discount is completely empty, skip validation
    return [];
  }

  if (typeof discount.name !== "string" || discount.name.trim() === "") {
    errors.push(
      `Discount #${
        index + 1
      }: 'name' is required and must be a non-empty string.`
    );
  }

  if (!discount?.value || discount.value.trim() === "") {
    errors.push(
      `Discount #${index + 1}: 'value' is required and must be a number.`
    );
  }

  if (typeof discount.comment !== "string" || discount.comment.trim() === "") {
    errors.push(
      `Discount #${
        index + 1
      }: 'comment' is required and must be a non-empty string.`
    );
  }

  return errors;
};

const validateDiscounts = (discounts) => {
  const errors = [];
  if (!Array.isArray(discounts)) return errors;

  discounts.forEach((discount, index) => {
    const discountErrors = isValidDiscount(discount, index);
    errors.push(...discountErrors);
  });

  return errors;
};

const generateInvoiceNumber = async (uiid) => { // structure: 25080001 (YY MM NUM)
  const now = new Date();
  return (
    now.getFullYear().toString().slice(-2) +
    String(now.getMonth() + 1).padStart(2, '0') +
    String(uiid).padStart(4, '0')
  );
};

const formatDiscountDisplay = (discount, tableAmountTotal) => {
  const discountValue = Number(discount?.value);
  const amountTotal = Number(tableAmountTotal);

  const isPercentage = discount?.type === 1;
  const isDiscountValid = !isNaN(discountValue);
  const isTotalValid = !isNaN(amountTotal);

  if (isPercentage) {
    const percentage = isDiscountValid ? discountValue.toFixed(2) : "0.00";
    const discountAmount = isDiscountValid && isTotalValid
      ? ((amountTotal * discountValue) / 100).toFixed(2)
      : "0.00";
    return `${percentage}% (${discountAmount} USD)`;
  } else {
    const flatAmount = isDiscountValid ? discountValue.toFixed(2) : "0.00";
    return `${flatAmount} USD`;
  }
}
 const calculateTotalDiscountInvoice = (discounts = [], tableAmountTotal = 0) => {
  const total = discounts.reduce((sum, discount) => {
    const value = parseFloat(discount.value);
    if (isNaN(value)) return sum;
    if (discount.type === 1) {
      return sum + (value / 100) * tableAmountTotal;
    } else if (discount.type === 2) {
      return sum + value;
    }
    return sum;
  }, 0);
  return Number(total.toFixed(2));
};
const validatePhoneNumber=(input,flag='IN')=>{
 // console.log("input",input);
  //console.log("flag",flag);
  const phoneNumber = parsePhoneNumberFromString(input,flag);
  if (phoneNumber && phoneNumber.isValid()) {
    return {
      valid: true,
      formatted: phoneNumber.formatInternational(), // e.g., "+91 98765 43210"
      e164: phoneNumber.number,                     // e.g., "+919876543210"
      country: phoneNumber.country,
    };
  }
  return { valid: false, message: 'Invalid phone number' };
}
const formatRange = (startStr, endStr) => {
  const start = new Date(startStr);
  const end = new Date(endStr);
  const options = { month: 'short', day: '2-digit' };
  const startFormatted = start.toLocaleDateString('en-US', options);
  const endFormatted = end.toLocaleDateString('en-US', options);
  const year = end.getFullYear();
  return `${startFormatted} - ${endFormatted} (${year})`;
};
const getExpenseArray = (expenseSections = [], formData = {}) => {
  return expenseSections.map((section, index) => {
    const selectValue = formData[`selectAmount_${index}`];
    return {
      type: typeof selectValue === "object" && selectValue?.value ? selectValue.value : selectValue || "",
      amount: formData[`amount_${index}`] || "",
      comments: formData[`expenseComment_${index}`] || "",
    };
  });
};

function groupByUiid(data) {
  const grouped = data.reduce((acc, item) => {
    const key = item.uiid;
    if (!acc[key]) {
      acc[key] = {
        ids: key,
        installmentId: []
      };
    }
    acc[key].installmentId.push(item._id);
    return acc;
  }, {});

  return Object.values(grouped);
}
// function groupDeductions(data=[]) {
//   const result = {
//     insurance: {},
//     regular: {}
//   };
//   data.forEach(item => {
//     const type = item.deductionType === 2 ? 'insurance' : 'regular';

//     // Initialize group if not already
//     if (!result[type].ids) {  
//       result[type].ids = item.uiid;
//       result[type].installmentId = [];
//     }

//     result[type].installmentId.push(item.id);
//   });

//   return result;
// }
function groupDeductions(data = []) {
  const result = {
    insurance: {},
    regular: []
  };

  data.forEach(item => {
    const { deductionType, uiid, id } = item;

    if (deductionType === 2) {
      // Single insurance object
      if (!result.insurance.ids) {
        result.insurance.ids = uiid;
        result.insurance.installmentId = [];
      }
      result.insurance.installmentId.push(id);
    } else {
      // Group regular by uiid
      let group = result.regular.find(entry => entry.ids === uiid);
      if (!group) {
        group = { ids: uiid, installmentId: [] };
        result.regular.push(group);
      }
      group.installmentId.push(id);
    }
  });

  return result;
}


function calculateAmountInForeignCurrency(inrAmount, exchangeRate) {
  const inr = Number(inrAmount);
  const rate = Number(exchangeRate);
  if (!isNaN(inr) && inr > 0 && !isNaN(rate) && rate > 0) {
    return (inr / rate).toFixed(2);
  }
  return "0.00"; // ⬅️ Default value
}
const formatToMMDDYYYY = (dateStr) => {
  const [day, month, year] = dateStr.split("/");
  return `${month}/${day}/${year}`;
};
function convertToMMDDYYYY(dateStr) {
  const date = new Date(dateStr);
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
}
const parseAmount = (value) => {
  const num = Number(value);
  return isNaN(num) ? 0 : num;
};
function generateInstallmentUpdatePayloads(input=[],payrollId) {
  return input.map((item) => ({
      coll: "EmpDeduction",
      uiid: item.uiid,
      patchId: item.id || item._id,
      payload: [
        {
          type: "SET",
          value: {
            "installments.$[elem]": {
              received: Number(item.deductionAmountLelf)||Number(item?.deductionAmountInput),
              ...(payrollId&&{payrollId})
            }
          }
        }
      ]
    }));
}
const updateDeductionsData = async (data) => {
  try {
    const response = await updateEmpDeductions(data);
    console.log("Updated successfully:", data.uiid);
    return response;
  } catch (error) {
    console.error("Update failed for:", data.uiid, error);
    throw new Error(`Failed to update deduction for uiid: ${data.uiid}`);
  }
};

const filterInstallments = (data) => {
    if (Array.isArray(data.regular)) {
        data.regular.forEach(item => {
            if (item.ids && Array.isArray(item.ids.installments)) {
                if (Array.isArray(item.installmentId)) {
                    const filteredInstallments = item.ids.installments.filter(installment =>
                        item.installmentId.includes(installment._id)
                    );
                    item.ids.installments = filteredInstallments;
                } else {
                    item.ids.installments = [];
                }
            } else {
                item.ids.installments = [];
            }
        });
    } else {
        console.error('Data.regular is not an array or is missing!');
    }

    return data;
};
function getCutoffEndDateWithDayjs(today = dayjs(),format) {
  const dayOfMonth = today.date();
  const monthsBack = dayOfMonth < 16 ? 2 : 1;
  const cutoff = today
    .subtract(monthsBack, 'month') 
    .endOf('month')               

  if(format) return cutoff.format(format)
  return cutoff.toDate(); 
}
const convertLocalFormatMMDDYYYY = (date) => {
  return dayjs(date).local().format('MM/DD/YYYY');
};

const convertToUSD = (amountInINR, exchangeRate) => {
  if (!exchangeRate || exchangeRate === 0) return 0;
  return (amountInINR / exchangeRate).toFixed(2);
};
const calculateBalances = async (empOtherPayemntsSelectTimeSheets = [], paidAmount = 0) => {
  const sortedData = empOtherPayemntsSelectTimeSheets.sort((a, b) => a.totalTimeAmount - b.totalTimeAmount);
  let remainingAmount = paidAmount;
  const updatedData = sortedData.map(record => {
    const totalAmount = record.totalTimeAmount || 0; // Ensure 'totalTimeAmount' exists or default to 0
    let balance = 0;
    const amounts=record?.amounts||{}
   let paid = (amounts?.paid || 0); // Get already paid amount or default to 0
    if (remainingAmount >= totalAmount) {
      console.log("paid+remainingAmount in else",paid+remainingAmount);
      paid = paid+totalAmount; // We can fully pay this record
      remainingAmount -= totalAmount; // Deduct from remainingAmount
      balance = 0; // No balance left for this record
    } else {
      console.log("paid+remainingAmount in else",paid+remainingAmount);
      paid = paid+remainingAmount; // Pay whatever is left in the remainingAmount
      balance = totalAmount - paid; // Set the balance to the remaining amount of this record
      remainingAmount = 0; // Once the remainingAmount is used up, set it to 0
    }

    // Step 4: Return updated record with 'balance' and 'paid' properties
    return {
      ...record,
      balance: balance, // Add the balance property
      paid: paid // Add the paid property for tracking
    };
  });
  if (remainingAmount > 0) {
    console.warn(`There is ${remainingAmount} amount left undeducted.`);
  }
  return updatedData;
};

const generateTimeSheetsUpdatePayloads =async (input = []) => {
  return input.map((item) => ({
    coll: "Timesheet", 
    uiid: item.uiid, 
    payload: [
      {
        type: "SET", // Update type
        value: {
          amounts: {
            paid: item?.paid // Set paid amount
          },
          // If balance is 0, mark the time sheet as fully paid
          ...(item?.balance === 0 && { paid: true })
        }
      }
    ]
  }));
};
const updateTimeSheetData = async (data) => {
  try {
    const response = await updateTimesheet(data);
    console.log("Updated successfully:", data.uiid);
    return response;
  } catch (error) {
    console.error("Update failed for:", data.uiid, error);
    throw new Error(`Failed to update deduction for uiid: ${data.uiid}`);
  }
};
const distributePayment = (input = []) => {
  if (input.length === 0) {
    return [];
  }

  return input.map(item => {
    let remainingPayment = isNaN(item.payment) ? 0 : parseFloat(item.payment);
    let updatedInstallments = item.pendingInstallments.map(installment => {
      let remainingReceivable = (installment.receivable || 0) - (installment.received || 0); // Correct calculation
      let paymentToApply = 0;
      let received = installment.received || 0; // Default 'received' to 0 if not set

      // Check if remaining payment can fully pay off the receivable
      if (remainingPayment >= remainingReceivable) {
        paymentToApply = remainingReceivable;
        received += paymentToApply;
        remainingPayment -= paymentToApply;
      } else {
        paymentToApply = remainingPayment; // Pay whatever is left
        received += paymentToApply;
        remainingPayment = 0; // No more payment left
      }

      // Return the updated installment with new 'received' value
      return {
        ...installment,
        received, // Update the received value
      };
    });

    // Return updated item with new installments and status
    return {
      ...item,
      pendingInstallments: updatedInstallments,
      status: remainingPayment === 0 ? 2 : 1, // Status 2 if all payment is distributed, else 1
    };
  });
};


const generateUpdatePayload = (input=[]) => {
  if (input.length === 0) {
    return [];
  }
 const result =input.map(item => {
    const { uiid, status, pendingInstallments } = item; // Destructure necessary fields from item

    // Iterate over each installment and create the update payload
    const installmentsPayload = pendingInstallments.map(item2 => {
      const { _id, received, comments = null } = item2;
      const patchId = _id;  // Set patchId from '_id'
      return {
        coll: "EmpDeduction",
        uiid: uiid,
        patchId: patchId,
        payload: [
          {
            type: "SET",
            value: {
              "installments.$[elem]": {
                received: received, 
                comments
              },
              ...(status === 2 && { status })  // Conditionally add 'status' if it's 2
            }
          }
        ]
      };
    });
   
    return installmentsPayload;
  }).flat();  
   return result.filter(entry => {
    const patch = entry.payload[0];
    const received = patch?.value?.["installments.$[elem]"]?.received;
    return received !== 0;
});
};


// const classifyInput = (input) => {
//   const trimmedInput = input.trim();
//   if (/^[\w.-]+@[\w.-]+\.[a-zA-Z]{2,}$/.test(trimmedInput)) {
//     return "Email"; // Matches email format
//   }
//   if (/^[\w.-]+\.[a-zA-Z]{2,}$/.test(trimmedInput)) {
//     return "Domain"; // Matches domain format (e.g., example.com)
//   }
//   return "Company"; // If neither email nor domain, assume it's a company name
// };
// Keep this list small & curated for frontend
const PUBLIC_TLDS = [
  "com", "net", "org", "io", "co", "in", "ai", "edu", "gov",
  "us", "uk", "ca", "au", "de", "fr", "jp", "sg"
];
const classifyInput = (input = "") => {
  const value = input.trim().toLowerCase();
  if (!value) return "Unknown";
  const emailRegex =
    /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
  if (emailRegex.test(value)) {
    return "Email";
  }
  const domainRegex = /^[a-z0-9.-]+\.[a-z]{2,}$/;
  if (domainRegex.test(value)) {
    const parts = value.split(".");
    const tld = parts[parts.length - 1];

    if (PUBLIC_TLDS.includes(tld)) {
      return "Domain";
    }
  }
  return "Company";
};


function transformShuffleData(shuffleData) {
  return shuffleData.map(item => {
    return item.assignedProspectData.map(assignment => {
      const prospect = assignment.prospectId || {};
      const job = assignment.jobId || {};
      const firstName = assignment.prospectId ? assignment.prospectId.firstName : null;
      const lastName = assignment.prospectId ? assignment.prospectId.lastName : null;
      const email = assignment.prospectId ? assignment.prospectId?.email : null;
      const companyName = job.companyId && job.companyId[0] ? job.companyId[0].name : null;
      const phone = prospect.mobile ? `${prospect.mobile.code || ""} ${prospect.mobile.number || ""}` : null;
      // Format the location as "State, City" (if both state and city exist)
      const location = prospect.location && prospect.location.state && prospect.location.city
        ? `${prospect.location.state.trim()}, ${prospect.location.city.trim()}`
        : ""; // Empty if no valid state and city
      return {
        first_name: firstName,
        last_name: lastName,
        email: email,
        company_name: companyName,
        phone: phone,
        location: location,
        lt_interest_status: 1,
        job_title: job.title || null // Default to an empty string if job title is missing
      };
    });
  }).flat();  // Flatten the array in case of nested data
}
function generateOutput(sampleData=[]) {
    const columns = {};
    sampleData.forEach(field => {
        columns[field.columnName] = {
            selectedType: field.selectedType,
            samples: field.samples
        };
    });
    const numRecords = columns.emailId.samples.length; 
    const output = [];
    for (let i = 0; i < numRecords; i++) {
        const record = {};
        Object.keys(columns).forEach(column => {
            const { selectedType, samples } = columns[column];
            const sampleValue = samples[i] || ""; 
            if (selectedType === "Customefiled") {
                record[column] = sampleValue;
            } else {
                record[selectedType] = sampleValue;
            }
        });
        output.push(record);
    }
    return output;
}
const staticFields = {
    "lt_interest_status": 1,
    "pl_value_lead": "High",
    "skip_if_in_workspace": true,
    "skip_if_in_campaign": true,
    "skip_if_in_list": true,
    "verify_leads_for_lead_finder": true,
    "verify_leads_on_import": true
};

const basicFields = ["email", "first_name", "last_name", "company_name", "phone", "personalization","website"];

function generateFinalOutputWithStaticFields(sampleData=[]) {
    const output = sampleData.map(record => {
        const finalRecord = { custom_variables: {} };
        Object.keys(record).forEach(field => {
            if (basicFields.includes(field)) {
                finalRecord[field] = record[field];
            } else {
                finalRecord.custom_variables[field] = record[field];
            }
        });
        Object.assign(finalRecord, staticFields);
        return finalRecord;
    });
    return output;
}

function encryptAll(obj) {
  if (obj === null || obj === undefined) return obj;
  if (obj instanceof Date) return obj;
  if (obj === "") return obj;
  if (typeof obj === "string" || typeof obj === "number") {
    return CryptoJS.AES.encrypt(String(obj), ENCRYPTION_KEY).toString();
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => encryptAll(item));
  }
  if (typeof obj === "object") {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      result[key] = encryptAll(value);
    }
    return result;
  }
  return obj;
}

function decryptAll(obj) {
  if (obj === null || obj === undefined) return obj;
  if (obj === "") return obj;

  if (typeof obj === "string") {
    try {
      const bytes = CryptoJS.AES.decrypt(obj, ENCRYPTION_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);

      return decrypted !== "" ? decrypted : "";
    } catch (e) {
      return obj;
    }
  }

  if (typeof obj === "number") return obj;

  if (Array.isArray(obj)) {
    return obj.map((item) => decryptAll(item));
  }

  if (typeof obj === "object") {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      result[key] = decryptAll(value);
    }
    return result;
  }

  return obj;
};
// export const getStartOfDay = (date) => convertToUTC(dayjs(date).startOf("day"));
// export const getEndOfDay = (date) => convertToUTC(dayjs(date).endOf("day"));
function normalizeToDateString(input) {
  if (!input) return null;
  // Case 1: already YYYY-MM-DD
  if (typeof input === "string") {
    if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
      return input;
    }
    const parsed = dayjs(input);
    if (!parsed.isValid()) {
      throw new Error(`Invalid date string: ${input}`);
    }
    return parsed.format("YYYY-MM-DD");
  }
  // Case 2: Date object
  if (input instanceof Date) {
    if (isNaN(input.getTime())) {
      throw new Error("Invalid Date object");
    }
    return dayjs(input).format("YYYY-MM-DD");
  }
  throw new Error(
    `Unsupported date type: ${Object.prototype.toString.call(input)}`
  );
}

export const getStartOfDay = (input) => {
 const dateStr = normalizeToDateString(input);
  return convertToUTC(`${dateStr} 00:00:00`);
}

export const getEndOfDay = (input) => {
  const dateStr = normalizeToDateString(input);
  return convertToUTC(`${dateStr} 23:59:59.999`);
}

export const sanitizeString = (str) => {
    if (typeof str !== "string") {
      return ""; // Return an empty string for non-string inputs
    }
    return str.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
  };
  export function normalizeQuotes(str) {
  const hasQuotes = /[“”'`]/g.test(str);
  if (hasQuotes) {
      return str.replace(/[“”'`]/g, '"');
  }
  return str;
}
export function asArray(value) {
  if (Array.isArray(value)) return value
  return []
}
export function isFileTypeMissingFromUrl(url) {
  if (typeof url !== "string" || !url.trim()) return false;
  const cleanUrl = url.split("?")[0];
  const fileName = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);
  if (!fileName.includes(".")) return true;
  const ext = fileName.split(".").pop();
  if (!ext || ext.trim().length === 0) return true;
  const allowedExt = ["pdf", "doc", "docx", "txt", "html","rtf"];
  return !allowedExt.includes(ext.toLowerCase());
}
export function hasContent(value) {
  if (typeof value !== "string") return false;
  return value.trim().length > 0;
}

export const getTimeZoneValue = (label) => {
  const found = localeTimeZoneOptions.find(
    option => option.label === label
  );
  return found ? found.value : null;
};

export const getTimeFormatValue = (label) => {
  const found = localeTimeFormatOptions.find(
    option => option.label === label
  );
  return found ? found.value : null;
};

export const toTitleCase = (text = "") => {
  if (!text) return "-";

  return text
    .toString()
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export default {
  getCombinedDateRange,
  splitByCase,
  mapDailyEntriesToRanges,
  calculateDiscountedTotal,
  mergeEntries,
  updateImmigrationData,
  groupDatesByUiid,
  validateFormFields,
  generateMonthStartToEnd,
  formatDate,
  convertEntryption,
  validateDiscounts,
  generateInvoiceNumber,
  formatDiscountDisplay,
  calculateTotalDiscountInvoice,
  validatePhoneNumber,
  formatRange,
  getExpenseArray,
  groupByUiid,
  calculateAmountInForeignCurrency,
  formatToMMDDYYYY,
  convertToMMDDYYYY,
  parseAmount,
  generateInstallmentUpdatePayloads,
  updateDeductionsData,
  groupDeductions,
  filterInstallments,
  getCutoffEndDateWithDayjs,
  convertLocalFormatMMDDYYYY,
  convertToUSD,
  calculateBalances,
  generateTimeSheetsUpdatePayloads,
  updateTimeSheetData,
  distributePayment,
  generateUpdatePayload,
  classifyInput,
  transformShuffleData,
  generateOutput,
  generateFinalOutputWithStaticFields,
  encryptAll,
  decryptAll,
  getStartOfDay,
  getEndOfDay,
  toTitleCase
};
